import React, { useState, useEffect } from "react";
import "./comm-records-styling.css";
import {
  BsFillArrowUpCircleFill,
  BsFillArrowDownCircleFill,
} from "react-icons/bs";
import Logs from "./Logs";

const LogsContainer = ({ calls, reload }) => {
  const [message, setMessage] = useState();
  const [callsArray, setCallsArray] = useState(calls);
  const [ascending, setAscending] = useState(false);

  useEffect(() => {
    // const sortedRecordings = [...callsArray].sort((a, b) => {
    //   if (ascending) {
    //     return a.dateCreated.localeCompare(b.dateCreated);
    //   } else {
    //     return b.dateCreated.localeCompare(a.dateCreated);
    //   }
    // });

    setCallsArray(calls);
  });

  // useEffect(() => {
  //   setTimeout(() => {
  //     setMessage("No Logs to display.");
  //   }, 10000);
  // }, []);

  return (
    <div className="comm-records-container">
      {calls.length > 0 ? (
        <>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th
                    className="table-heading"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      border: "1px",
                    }}
                  >
                    <p>Date</p>
                    <div className="table-heading-icon-wrapper"></div>{" "}
                  </th>
                  <th className="table-heading">Call Start Time</th>
                  <th className="table-heading">Type</th>
                  <th className="table-heading">To</th>
                  <th className="table-heading">Duration</th>
                  {/* <th className="table-heading">Price</th> */}
                  <th className="table-heading">Status</th>
                </tr>
              </thead>
              <tbody>
                {callsArray.map((call) => (
                  <Logs
                    key={call._id}
                    reload={reload}
                    call={call}
                    // from={call.from}
                    // to={call.to}
                    // recordingUrl={call.recordingUrl}
                    // recordingStart={call.recordingStart}
                    // duration={call.recordingDuration}
                    // type={call.type}

                    // archived={call.isArchived}
                  />
                ))}
              </tbody>
            </table>
          </div>
          <p>*Time: 24hr timestamp shown in local timezone.</p>{" "}
        </>
      ) : (
        <p>No Logs to display.</p>
      )}
    </div>
  );
};

export default LogsContainer;
